(function () {
  'use strict';

  var TESTIMONIAL_VIDEO_CLICK_SELECTOR = '.play-button-wrapper';
  var TESTIMONIAL_VIDEO_CLICK_EVENT_NAME = 'custom_testimonial_video_click';

  var PROMO_SPOTLIGHT_CLICK_SELECTOR = '.ed-image-promo-section .promo-item-container';
  var PROMO_SPOTLIGHT_CLICK_EVENT_NAME = 'custom_promo_spotlight_click';

  var FACE_MAPPING_CTA_SELECTOR = 'a.button.button--primary[href="/pages/face-mapping"], a.button.button--primary[href="https://www.dermalogica.de/pages/face-mapping"]';
  var FACE_MAPPING_CTA_EVENT_NAME = 'custom_face_mapping_cta_click';
  var DOOFINDER_SEARCH_INPUT_SELECTOR = '.dfd-searchbox-input, input[type="search"]';
  var DOOFINDER_RESULTS_SELECTOR = '.dfd-results';
  var DESKTOP_DOOFINDER_RESULT_CLICK_SELECTOR = 'a.dfd-card-link[dfd-click="item-click"]';
  var DESKTOP_DOOFINDER_RESULTS_VIEW_EVENT_NAME = 'custom_desktop_doofinder_search_results_view';
  var DESKTOP_DOOFINDER_RESULT_CLICK_EVENT_NAME = 'custom_desktop_doofinder_search_result_click';

  var CART_LOYALTY_CLICK_SELECTOR = '.ed-cart-loyalty-program-link';
  var CART_LOYALTY_CLICK_EVENT_NAME = 'custom_cart_loyalty_program_click';
  var DESKTOP_HEADER_CART_ICON_SELECTOR = '#cart-icon-bubble.header__icon--cart';
  var DESKTOP_HEADER_CART_ICON_EVENT_NAME = 'custom_desktop_header_cart_icon_click';
  var DESKTOP_CART_QUANTITY_BUTTON_SELECTOR = 'cart-drawer-items .quantity__button, cart-items .quantity__button';
  var DESKTOP_CART_QUANTITY_BUTTON_EVENT_NAME = 'custom_desktop_cart_quantity_button_click';

  var DESKTOP_MEGA_MENU_NAV_SELECTOR = '.header__inline-menu .ed-mega-menu .mm-nav-container a.mm-link';
  var DESKTOP_MEGA_MENU_PROMO_SELECTOR = '.header__inline-menu .ed-mega-menu .mm-item-container a';
  var DESKTOP_MEGA_MENU_NAV_EVENT_NAME = 'custom_desktop_mega_menu_nav_click';
  var DESKTOP_MEGA_MENU_PROMO_EVENT_NAME = 'custom_desktop_mega_menu_promo_click';

  var DESKTOP_PRODUCT_TAB_SELECTOR = '.product-description-with-tabs .tabs-container .product__accordion > details > summary';
  var DESKTOP_PRODUCT_TAB_EVENT_NAME = 'custom_desktop_product_tab_open';
  var DESKTOP_PDP_VARIANT_SELECTOR = '#variant_selector_1 input[type="radio"], #variant_selector_1 label';
  var DESKTOP_PDP_VARIANT_EVENT_NAME = 'custom_desktop_pdp_variant_select';
  var DESKTOP_PDP_MEDIA_GALLERY_SELECTOR = '.product__modal-opener--image .product__media-toggle';
  var DESKTOP_PDP_MEDIA_GALLERY_EVENT_NAME = 'custom_desktop_pdp_media_gallery_open';
  var DESKTOP_PDP_SUBSCRIPTION_OPTION_SELECTOR = '.subscription-widget__options .subscription-option';
  var DESKTOP_PDP_SUBSCRIPTION_OPTION_EVENT_NAME = 'custom_desktop_pdp_subscription_option_select';

  var DESKTOP_COLLECTION_FILTER_OPEN_SELECTOR = '.facets #FacetsWrapperDesktop .js-filter > summary.facets__summary';
  var DESKTOP_COLLECTION_FILTER_OPEN_EVENT_NAME = 'custom_desktop_collection_filter_open';
  var DESKTOP_COLLECTION_FILTER_APPLY_EVENT_NAME = 'custom_desktop_collection_filter_apply';
  var DESKTOP_COLLECTION_QUICK_ADD_SELECTOR = '#product-grid .card-product-atc .collection-atc';
  var DESKTOP_COLLECTION_QUICK_ADD_EVENT_NAME = 'custom_desktop_collection_quick_add_click';
  var DESKTOP_PRODUCT_RECOMMENDATION_SELECTOR = '.product-recommendations .card__information a.full-unstyled-link';
  var DESKTOP_PRODUCT_RECOMMENDATION_EVENT_NAME = 'custom_desktop_product_recommendation_click';

  var DESKTOP_CART_DRAWER_GIFT_ADD_SELECTOR = '.ed-cart-drawer .drawer__inner ed-gift-system-main ed-gift-item .btn-add-gift-to-cart-drawer';
  var DESKTOP_CART_DRAWER_SAMPLE_ADD_SELECTOR = '.ed-cart-drawer .drawer__inner ed-gift-system-main ed-gift-item-select-popup form.popup-product-atc .popup-submit-button button';
  var DESKTOP_CART_DRAWER_GIFT_ADD_EVENT_NAME = 'custom_desktop_cart_drawer_gift_add_click';
  var DESKTOP_CART_DRAWER_SAMPLE_SELECT_SELECTOR = '.ed-cart-drawer .drawer__inner ed-gift-system-main ed-gift-item-select-popup .confirm-gift-button';
  var DESKTOP_CART_DRAWER_SAMPLE_SELECT_EVENT_NAME = 'custom_desktop_cart_drawer_luxury_sample_select';
  var DESKTOP_CART_DRAWER_OPEN_EVENT_NAME = 'custom_desktop_cart_drawer_open';

  var CHAT_OPEN_EVENT_NAME = 'custom_chat_open';

  var DESKTOP_BREAKPOINT = '(min-width: 990px)';
  var DEDUPE_WINDOW_MS = 750;

  var ALLOWED_PRODUCT_TAB_NAMES = {
    'beschreibung': 'Beschreibung',
    'dein nutzen': 'Dein Nutzen',
    'anwendung': 'Anwendung',
    'inhaltsstoffe': 'Inhaltsstoffe'
  };

  var CLICK_EVENT_MAPPINGS = [
    // Tracks clicks on testimonial video play buttons.
    {
      selector: TESTIMONIAL_VIDEO_CLICK_SELECTOR,
      eventName: TESTIMONIAL_VIDEO_CLICK_EVENT_NAME
    },

    // Tracks clicks on promo spotlight tiles in the image promo section.
    {
      selector: PROMO_SPOTLIGHT_CLICK_SELECTOR,
      eventName: PROMO_SPOTLIGHT_CLICK_EVENT_NAME
    },

    // Tracks primary face mapping CTA clicks and includes surrounding section context.
    {
      selector: FACE_MAPPING_CTA_SELECTOR,
      eventName: FACE_MAPPING_CTA_EVENT_NAME
    },

    // Desktop only: tracks clicks on product links inside Doofinder search results.
    {
      selector: DESKTOP_DOOFINDER_RESULT_CLICK_SELECTOR,
      eventName: DESKTOP_DOOFINDER_RESULT_CLICK_EVENT_NAME
    },

    // Tracks clicks on the cart drawer loyalty CTA.
    {
      selector: CART_LOYALTY_CLICK_SELECTOR,
      eventName: CART_LOYALTY_CLICK_EVENT_NAME
    },

    // Desktop only: tracks clicks on the header cart icon, including its count bubble wrapper.
    {
      selector: DESKTOP_HEADER_CART_ICON_SELECTOR,
      eventName: DESKTOP_HEADER_CART_ICON_EVENT_NAME
    },

    // Desktop only: tracks quantity plus/minus interactions for items already in the cart.
    {
      selector: DESKTOP_CART_QUANTITY_BUTTON_SELECTOR,
      eventName: DESKTOP_CART_QUANTITY_BUTTON_EVENT_NAME
    },

    // Desktop only: tracks clicks on real navigation links inside the mega menu.
    {
      selector: DESKTOP_MEGA_MENU_NAV_SELECTOR,
      eventName: DESKTOP_MEGA_MENU_NAV_EVENT_NAME
    },

    // Desktop only: tracks clicks on promo/image tiles inside the mega menu.
    {
      selector: DESKTOP_MEGA_MENU_PROMO_SELECTOR,
      eventName: DESKTOP_MEGA_MENU_PROMO_EVENT_NAME
    },

    // Desktop only: tracks openings of the selected PDP product information tabs.
    {
      selector: DESKTOP_PRODUCT_TAB_SELECTOR,
      eventName: DESKTOP_PRODUCT_TAB_EVENT_NAME
    },

    // Desktop only: tracks PDP variant selections from the first radio selector.
    {
      selector: DESKTOP_PDP_VARIANT_SELECTOR,
      eventName: DESKTOP_PDP_VARIANT_EVENT_NAME
    },

    // Desktop only: tracks opening of the PDP image gallery modal from product media.
    {
      selector: DESKTOP_PDP_MEDIA_GALLERY_SELECTOR,
      eventName: DESKTOP_PDP_MEDIA_GALLERY_EVENT_NAME
    },

    // Desktop only: tracks selection clicks on Recharge subscription options on the PDP.
    {
      selector: DESKTOP_PDP_SUBSCRIPTION_OPTION_SELECTOR,
      eventName: DESKTOP_PDP_SUBSCRIPTION_OPTION_EVENT_NAME
    },

    // Desktop only: tracks opening of collection filter groups on collection pages.
    {
      selector: DESKTOP_COLLECTION_FILTER_OPEN_SELECTOR,
      eventName: DESKTOP_COLLECTION_FILTER_OPEN_EVENT_NAME
    },

    // Desktop only: tracks quick add-to-cart button clicks on collection product cards.
    {
      selector: DESKTOP_COLLECTION_QUICK_ADD_SELECTOR,
      eventName: DESKTOP_COLLECTION_QUICK_ADD_EVENT_NAME
    },

    // Desktop only: tracks clicks on product links inside the PDP recommendations block.
    {
      selector: DESKTOP_PRODUCT_RECOMMENDATION_SELECTOR,
      eventName: DESKTOP_PRODUCT_RECOMMENDATION_EVENT_NAME
    },

    // Desktop only: tracks direct add-to-cart clicks for single free gifts in the cart drawer.
    {
      selector: DESKTOP_CART_DRAWER_GIFT_ADD_SELECTOR,
      eventName: DESKTOP_CART_DRAWER_GIFT_ADD_EVENT_NAME
    },

    // Desktop only: tracks the final add click for luxury samples inside the cart drawer popup.
    {
      selector: DESKTOP_CART_DRAWER_SAMPLE_ADD_SELECTOR,
      eventName: DESKTOP_CART_DRAWER_GIFT_ADD_EVENT_NAME
    },

    // Desktop only: tracks the confirmed luxury sample selection inside the cart drawer popup.
    {
      selector: DESKTOP_CART_DRAWER_SAMPLE_SELECT_SELECTOR,
      eventName: DESKTOP_CART_DRAWER_SAMPLE_SELECT_EVENT_NAME
    }
  ];

  var lastPublishedByElement = new WeakMap();
  var hasTrackedChatOpen = false;
  var lastDoofinderTrackedQuery = '';

  function canPublishAnalytics() {
    return Boolean(
      window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
    );
  }

  function normalizeText(value) {
    if (typeof value !== 'string') {
      return '';
    }

    return value.replace(/\s+/g, ' ').trim();
  }

  function isDesktopTrackingEnabled() {
    if (typeof window.matchMedia !== 'function') {
      return true;
    }

    return window.matchMedia(DESKTOP_BREAKPOINT).matches;
  }

  function isCollectionPage() {
    return /(^|\/)collections\//.test(window.location.pathname);
  }

  function isProductPage() {
    return /(^|\/)products\//.test(window.location.pathname);
  }

  function getDoofinderSearchQuery() {
    var searchInputElement = document.querySelector(DOOFINDER_SEARCH_INPUT_SELECTOR);

    return normalizeText(searchInputElement && searchInputElement.value);
  }

  function getDoofinderResultLinks() {
    return Array.from(document.querySelectorAll(DESKTOP_DOOFINDER_RESULT_CLICK_SELECTOR));
  }

  function buildEventPayload(element, selector) {
    var payload = {
      selector: selector,
      url: window.location.href,
      pathname: window.location.pathname,
      timestamp: new Date().toISOString()
    };

    var elementText = normalizeText(element && element.textContent);
    var href =
      element && typeof element.getAttribute === 'function'
        ? element.getAttribute('href')
        : '';

    if (elementText) {
      payload.element_text = elementText;
    }

    if (href) {
      payload.href = href;
    }

    return payload;
  }

  function shouldSkipDuplicate(element, eventName) {
    if (!element) {
      return false;
    }

    var now = Date.now();
    var lastPublished = lastPublishedByElement.get(element);

    if (
      lastPublished &&
      lastPublished.eventName === eventName &&
      now - lastPublished.timestamp < DEDUPE_WINDOW_MS
    ) {
      return true;
    }

    lastPublishedByElement.set(element, {
      eventName: eventName,
      timestamp: now
    });

    return false;
  }

  /**
   * Mirrors an event into the page's real window.dataLayer. Elevar's GTM pixel
   * runs in a sandboxed iframe and cannot reach this dataLayer from there, so
   * the theme has to push into it from the same JS context as GTM itself.
   */
  function pushToDataLayer(eventName, payload) {
    var dataLayerEvent = { event: eventName };
    var key;

    window.dataLayer = window.dataLayer || [];

    if (payload && typeof payload === 'object') {
      for (key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          dataLayerEvent[key] = payload[key];
        }
      }
    }

    window.dataLayer.push(dataLayerEvent);
  }

  function publishCustomEvent(eventName, payload, element) {
    var published = true;

    if (!eventName || !canPublishAnalytics()) {
      return false;
    }

    if (element && shouldSkipDuplicate(element, eventName)) {
      return false;
    }

    try {
      window.Shopify.analytics.publish(eventName, payload);
    } catch (error) {
      console.error('Analytics publish failed:', error, eventName, payload);
      published = false;
    }

    try {
      pushToDataLayer(eventName, payload);
    } catch (error) {
      console.error('Data layer push failed:', error, eventName, payload);
    }

    return published;
  }

  function getClosestMatch(target, selector) {
    var baseElement;

    if (!target || !selector) {
      return null;
    }

    baseElement = target.nodeType === 1 ? target : target.parentElement;

    if (!baseElement || typeof baseElement.closest !== 'function') {
      return null;
    }

    return baseElement.closest(selector);
  }

  function getParentMegaMenuText(element) {
    var detailsElement = element && element.closest('details[mega-menu="true"]');
    var summaryTextElement;

    if (!detailsElement) {
      return '';
    }

    summaryTextElement = detailsElement.querySelector('summary.header__menu-item span');

    return summaryTextElement ? normalizeText(summaryTextElement.textContent) : '';
  }

  function getSectionContextElement(element) {
    return element && element.closest('[id^="shopify-section-"], .shopify-section, section');
  }

  function getSectionContextHeading(sectionElement) {
    var headingElement = sectionElement && sectionElement.querySelector('h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, .h6');

    return normalizeText(headingElement && headingElement.textContent);
  }

  /**
   * Tracks testimonial video clicks with card-specific context because the
   * clicked play button itself does not contain meaningful visible text.
   */
  function buildTestimonialVideoClickPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var cardElement = element && element.closest('.video-testimonial-card');
    var listItemElement = element && element.closest('.video-testimonial-list__item');
    var titleElement = cardElement && cardElement.querySelector('.video-testimonial');
    var textElement = cardElement && cardElement.querySelector('.video-testimonial-text');
    var productElement = listItemElement && listItemElement.querySelector('.product-row .product');
    var instagramLinkElement = cardElement && cardElement.querySelector('.testimonial-card-footer a');
    var videoElement = cardElement && cardElement.querySelector('video');

    payload.ui_component = 'video_testimonials';

    if (titleElement) {
      payload.testimonial_title = normalizeText(titleElement.textContent);
    }

    if (textElement) {
      payload.testimonial_text = normalizeText(textElement.textContent);
    }

    if (productElement) {
      payload.product_title = normalizeText(productElement.textContent);
      payload.product_href = productElement.getAttribute('href') || '';
    }

    if (instagramLinkElement) {
      payload.instagram_url = instagramLinkElement.getAttribute('href') || '';
    }

    if (videoElement) {
      payload.video_poster = videoElement.getAttribute('poster') || '';
    }

    return payload;
  }

  /**
   * Tracks promo spotlight clicks with the visible promo title and CTA label
   * so reporting can distinguish between individual promo tiles.
   */
  function buildPromoSpotlightClickPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var titleElement = element && element.querySelector('.promo-heading');
    var buttonElement = element && element.querySelector('.button-container .button');
    var imageElement = element && element.querySelector('.image-wrapper img');

    payload.ui_component = 'image_promo_section';

    if (titleElement) {
      payload.promo_title = normalizeText(titleElement.textContent);
    }

    if (buttonElement) {
      payload.promo_cta_text = normalizeText(buttonElement.textContent);
    }

    if (imageElement) {
      payload.image_src = imageElement.getAttribute('src') || '';
    }

    return payload;
  }

  /**
   * Tracks primary face mapping CTA clicks with lightweight section context so
   * the same destination can be distinguished across different theme placements.
   */
  function buildFaceMappingCtaPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var sectionElement = getSectionContextElement(element);
    var sectionHeading = getSectionContextHeading(sectionElement);

    payload.ui_component = 'face_mapping_cta';

    if (sectionElement) {
      payload.context_section_id = sectionElement.id || '';
      payload.context_section_type = sectionElement.getAttribute('data-section') || sectionElement.tagName.toLowerCase();
    }

    if (sectionHeading) {
      payload.context_heading = sectionHeading;
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks when Doofinder renders product results for a typed query and keeps
   * the payload intentionally small for UI-level search usage analysis.
   */
  function buildDesktopDoofinderResultsViewPayload() {
    var query = getDoofinderSearchQuery();
    var resultLinks = getDoofinderResultLinks();

    if (!query || !resultLinks.length) {
      return null;
    }

    return {
      selector: DOOFINDER_RESULTS_SELECTOR,
      url: window.location.href,
      pathname: window.location.pathname,
      timestamp: new Date().toISOString(),
      ui_component: 'doofinder_search',
      search_term: query,
      result_count: resultLinks.length
    };
  }

  /**
   * Desktop only.
   * Tracks clicks on Doofinder search result products with the active search
   * term and clicked result title for lightweight search optimization analysis.
   */
  function buildDesktopDoofinderResultClickPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var cardElement = element && element.closest('.dfd-card');
    var titleElement = (cardElement && cardElement.querySelector('.dfd-card-title')) || (element && element.querySelector('.dfd-card-title'));
    var searchTerm = getDoofinderSearchQuery();

    payload.ui_component = 'doofinder_search';

    if (searchTerm) {
      payload.search_term = searchTerm;
    }

    if (titleElement) {
      payload.result_title = normalizeText(titleElement.textContent);
    } else if (payload.element_text) {
      payload.result_title = payload.element_text;
    }

    return payload;
  }

  /**
   * Tracks cart drawer loyalty CTA clicks with drawer-specific context so the
   * same CTA can be distinguished between populated and empty drawer states.
   */
  function buildCartLoyaltyClickPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var loyaltyTextElement = element && element.querySelector('.ed-cart-loyalty-program-text');
    var isEmptyDrawerState = Boolean(element && element.closest('.drawer__inner-empty'));

    payload.ui_component = 'cart_drawer_loyalty';
    payload.drawer_state = isEmptyDrawerState ? 'empty' : 'filled';

    if (loyaltyTextElement) {
      payload.loyalty_cta_text = normalizeText(loyaltyTextElement.textContent);
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks quantity plus/minus clicks for products already in the cart and
   * includes only lightweight cart context for UI usage analysis.
   */
  function buildDesktopCartQuantityButtonPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var cartContainerElement = element && element.closest('cart-drawer-items, cart-items');
    var cartItemElement = element && element.closest('.cart-item');
    var productTitleElement = cartItemElement && cartItemElement.querySelector('.cart-item__name');

    payload.ui_component = 'cart_quantity_controls';
    payload.quantity_action = element && element.getAttribute('name') ? element.getAttribute('name') : '';
    payload.cart_context = cartContainerElement && cartContainerElement.tagName
      ? cartContainerElement.tagName.toLowerCase() === 'cart-drawer-items'
        ? 'drawer'
        : 'page'
      : '';

    if (productTitleElement) {
      payload.product_title = normalizeText(productTitleElement.textContent);
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks clicks on real navigation links inside the mega menu and includes
   * the top-level menu label plus the clicked column title for reporting.
   */
  function buildDesktopMegaMenuNavPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var listElement = element && element.closest('.mm-list');
    var columnTitleElement;
    var parentMenuText = getParentMegaMenuText(element);

    payload.navigation_type = 'desktop_mega_menu_nav';

    if (parentMenuText) {
      payload.parent_menu_text = parentMenuText;
    }

    if (listElement) {
      columnTitleElement = listElement.querySelector('.mm-title');

      if (columnTitleElement) {
        payload.column_title = normalizeText(columnTitleElement.textContent);
      }
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks clicks on promo/image tiles inside the mega menu separately from
   * standard navigation links so both click types can be analyzed independently.
   */
  function buildDesktopMegaMenuPromoPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var parentMenuText = getParentMegaMenuText(element);
    var promoTextElement = element && element.querySelector('.text-container span');
    var imageElement = element && element.querySelector('img');

    payload.navigation_type = 'desktop_mega_menu_promo';

    if (parentMenuText) {
      payload.parent_menu_text = parentMenuText;
    }

    if (promoTextElement) {
      payload.promo_text = normalizeText(promoTextElement.textContent);
    }

    if (imageElement) {
      if (imageElement.getAttribute('alt')) {
        payload.image_alt = normalizeText(imageElement.getAttribute('alt'));
      }

      if (imageElement.getAttribute('src')) {
        payload.image_src = imageElement.getAttribute('src');
      }
    }

    return payload;
  }

  function getProductTabName(summaryElement) {
    var titleElement = summaryElement && summaryElement.querySelector('.accordion__title');

    return normalizeText(titleElement && titleElement.textContent);
  }

  function getAllowedProductTabName(summaryElement) {
    var tabName = getProductTabName(summaryElement);
    var normalizedTabName = normalizeText(tabName).toLowerCase();

    return ALLOWED_PRODUCT_TAB_NAMES[normalizedTabName] || '';
  }

  function getVariantSelectorInput(element) {
    var inputId;

    if (!element) {
      return null;
    }

    if (element.matches && element.matches('input[type="radio"]')) {
      return element;
    }

    if (element.matches && element.matches('label')) {
      inputId = element.getAttribute('for');

      if (inputId) {
        return document.getElementById(inputId);
      }
    }

    return element.querySelector && element.querySelector('input[type="radio"]')
      ? element.querySelector('input[type="radio"]')
      : null;
  }

  /**
   * Desktop only.
   * Tracks PDP variant selections from the first radio-based variant selector
   * and resolves label clicks back to the selected radio value for reporting.
   */
  function buildDesktopPdpVariantPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var inputElement = getVariantSelectorInput(element);
    var fieldsetElement = inputElement && inputElement.closest('#variant_selector_1');
    var optionNameElement = fieldsetElement && fieldsetElement.querySelector('.ed-option-name');
    var optionLabelElement = inputElement && fieldsetElement
      ? fieldsetElement.querySelector('label[for="' + inputElement.id + '"]')
      : null;

    payload.ui_component = 'pdp_variant_selector';

    if (optionNameElement) {
      payload.option_name = normalizeText(optionNameElement.textContent);
    }

    if (inputElement && inputElement.value) {
      payload.variant_value = normalizeText(inputElement.value);
    }

    if (optionLabelElement) {
      payload.variant_label = normalizeText(optionLabelElement.textContent);
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks PDP image gallery modal opens from the main product media and
   * includes lightweight media context to identify which gallery item was used.
   */
  function buildDesktopPdpMediaGalleryPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var modalOpenerElement = element && element.closest('.product__modal-opener--image');
    var mediaGalleryElement = element && element.closest('media-gallery');

    payload.ui_component = 'pdp_media_gallery';

    if (element && element.getAttribute('data-media-id')) {
      payload.media_id = element.getAttribute('data-media-id');
    }

    if (mediaGalleryElement && mediaGalleryElement.getAttribute('data-desktop-layout')) {
      payload.gallery_layout = mediaGalleryElement.getAttribute('data-desktop-layout');
    }

    if (modalOpenerElement && modalOpenerElement.className) {
      payload.media_opener_type = normalizeText(modalOpenerElement.className.replace(/\s+/g, ' '));
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks clicks on Recharge subscription options on the PDP to measure
   * widget interaction without duplicating downstream subscription purchase tracking.
   */
  function buildDesktopPdpSubscriptionOptionPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var titleElement = element && element.querySelector('.subscription-widget__option-title');
    var textElement = element && element.querySelector('.subscription-widget__option-text');

    payload.ui_component = 'pdp_subscription_widget';

    if (element && element.getAttribute('data-option-type')) {
      payload.subscription_option_type = element.getAttribute('data-option-type');
    }

    if (titleElement) {
      payload.subscription_option_title = normalizeText(titleElement.textContent);
    }

    if (textElement) {
      payload.subscription_option_text = normalizeText(textElement.textContent);
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks openings of the approved PDP information tabs and intentionally
   * ignores close interactions to keep the event focused on content engagement.
   */
  function buildDesktopProductTabPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var tabName = getAllowedProductTabName(element);

    payload.ui_component = 'product_information_tabs';
    payload.tab_name = tabName;
    payload.tab_action = 'open';

    return payload;
  }

  function getDesktopCollectionFilterLabel(summaryElement) {
    var labelElement = summaryElement && summaryElement.querySelector('div > span');

    return normalizeText(labelElement && labelElement.textContent);
  }

  /**
   * Desktop only.
   * Tracks opening of collection filter disclosures on collection pages
   * before the disclosure state changes in the UI.
   */
  function buildDesktopCollectionFilterOpenPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var detailsElement = element && element.closest('.js-filter');
    var filterLabel = getDesktopCollectionFilterLabel(element);

    payload.ui_component = 'collection_filters';
    payload.filter_action = 'open';

    if (filterLabel) {
      payload.filter_label = filterLabel;
    }

    if (detailsElement) {
      payload.filter_group_index = detailsElement.getAttribute('data-index') || '';
      payload.filter_type = detailsElement.querySelector('price-range') ? 'price_range' : 'list';
    }

    return payload;
  }

  /**
   * Reads the visible active desktop facets after the collection results re-render.
   * Assistive text is stripped so only the user-facing active filter labels remain.
   */
  function getActiveDesktopFacetLabels() {
    return Array.from(
      document.querySelectorAll('.active-facets-desktop .active-facets__button--light .active-facets__button-inner')
    )
      .map(function (element) {
        var clone = element.cloneNode(true);

        clone.querySelectorAll('.visually-hidden').forEach(function (hiddenElement) {
          hiddenElement.remove();
        });

        return normalizeText(clone.textContent);
      })
      .filter(Boolean);
  }

  function getDesktopProductCountText() {
    var countElement = document.getElementById('ProductCountDesktop');

    return normalizeText(countElement && countElement.textContent);
  }

  function parseFilterParams(searchParams) {
    var params = new URLSearchParams(searchParams || '');
    var filterEntries = [];

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) {
        filterEntries.push({
          key: key,
          value: value
        });
      }
    });

    return filterEntries;
  }

  function serializeFilterParams(entries) {
    return entries
      .map(function (entry) {
        return entry.key + '=' + entry.value;
      })
      .sort()
      .join('&');
  }

  function getTriggeredDesktopFilterLabel(event) {
    var jsFilter = event && event.target && event.target.closest('.js-filter');
    var summaryElement = jsFilter && jsFilter.querySelector('summary.facets__summary');

    return getDesktopCollectionFilterLabel(summaryElement);
  }

  /**
   * Desktop only.
   * Tracks collection filter applications after the AJAX refresh completes so
   * the event reflects the final visible filter state and updated result count.
   */
  function buildDesktopCollectionFilterApplyPayload(context) {
    var payload = {
      selector: '#FacetFiltersForm',
      url: window.location.href,
      pathname: window.location.pathname,
      timestamp: new Date().toISOString(),
      ui_component: 'collection_filters',
      filter_action: 'apply',
      active_filter_count: context.activeFilterCount,
      result_count_text: context.resultCountText,
      filter_query: context.filterQuery
    };

    if (context.triggeredFilterLabel) {
      payload.triggered_filter_label = context.triggeredFilterLabel;
    }

    if (context.activeFilterLabels.length) {
      payload.active_filter_labels = context.activeFilterLabels;
    }

    return payload;
  }

  function getGiftItemTitle(giftItemElement) {
    var titleElement = giftItemElement && giftItemElement.querySelector('.gift-product-title');

    return normalizeText(titleElement && titleElement.textContent);
  }

  function getSelectedPopupGiftTitle(formElement) {
    var titleElement = formElement && formElement.querySelector('.ed-item-title');

    return normalizeText(titleElement && titleElement.textContent);
  }

  function getGiftVariantId(formElement) {
    var variantInput = formElement && formElement.querySelector('input[name="id"]');

    return variantInput ? variantInput.value : '';
  }

  function getSelectedPopupGiftForm(popupElement) {
    var activeRadio = popupElement && popupElement.querySelector('.gift-select-radio:checked');

    return activeRadio ? activeRadio.closest('form.popup-product-atc') : null;
  }

  function getCartDrawerOpenSource(cartDrawerElement, triggeredBy) {
    if (triggeredBy && triggeredBy.id === 'cart-icon-bubble') {
      return 'header_cart_icon';
    }

    if (cartDrawerElement && cartDrawerElement.isCustomAtcButton) {
      return 'custom_atc';
    }

    if (cartDrawerElement && cartDrawerElement.productId) {
      return 'product_add_to_cart';
    }

    return 'unknown';
  }

  /**
   * Desktop only.
   * Tracks actual cart drawer openings by hooking into the drawer open method
   * so the event reflects when the drawer really becomes active in the UI.
   */
  function buildDesktopCartDrawerOpenPayload(cartDrawerElement, triggeredBy) {
    return {
      selector: 'cart-drawer',
      url: window.location.href,
      pathname: window.location.pathname,
      timestamp: new Date().toISOString(),
      ui_component: 'cart_drawer',
      drawer_state: cartDrawerElement && cartDrawerElement.classList.contains('is-empty') ? 'empty' : 'filled',
      open_source: getCartDrawerOpenSource(cartDrawerElement, triggeredBy)
    };
  }

  /**
   * Desktop only.
   * Tracks the confirmed luxury sample choice in the cart drawer popup before
   * the selected sample is submitted to cart and includes the chosen sample.
   */
  function buildDesktopCartDrawerSampleSelectPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var popupElement = element && element.closest('ed-gift-item-select-popup');
    var giftItemElement = element && element.closest('ed-gift-item');
    var selectedFormElement = getSelectedPopupGiftForm(popupElement);
    var selectedGiftTitle = getSelectedPopupGiftTitle(selectedFormElement);
    var giftOfferTitle = getGiftItemTitle(giftItemElement);

    payload.ui_component = 'cart_drawer_gift_system';
    payload.gift_action = 'select';
    payload.gift_type = 'luxury_sample';

    if (selectedGiftTitle) {
      payload.gift_title = selectedGiftTitle;
    }

    if (giftOfferTitle) {
      payload.gift_offer_title = giftOfferTitle;
    }

    if (giftItemElement) {
      if (giftItemElement.getAttribute('index')) {
        payload.gift_index = giftItemElement.getAttribute('index');
      }

      if (giftItemElement.getAttribute('price-target')) {
        payload.gift_price_target = giftItemElement.getAttribute('price-target');
      }
    }

    if (selectedFormElement) {
      if (getGiftVariantId(selectedFormElement)) {
        payload.gift_variant_id = getGiftVariantId(selectedFormElement);
      }
    }

    return payload;
  }

  /**
   * Desktop only.
   * Tracks the final click used to add a free gift from the cart drawer and
   * distinguishes between direct gift adds and luxury sample selections.
   */
  function buildDesktopCartDrawerGiftAddPayload(element, selector) {
    var payload = buildEventPayload(element, selector);
    var formElement = element && element.closest('form');
    var giftItemElement = element && element.closest('ed-gift-item');
    var isSampleSelection = Boolean(element && element.closest('ed-gift-item-select-popup'));
    var selectedGiftTitle = isSampleSelection
      ? getSelectedPopupGiftTitle(formElement)
      : getGiftItemTitle(giftItemElement);
    var giftOfferTitle = getGiftItemTitle(giftItemElement);
    var giftType = giftItemElement && giftItemElement.getAttribute('multiple-enabled') === 'true'
      ? 'luxury_sample'
      : 'gift';

    payload.ui_component = 'cart_drawer_gift_system';
    payload.gift_action = 'add';
    payload.gift_type = giftType;
    payload.gift_selection_mode = isSampleSelection ? 'sample_choice' : 'direct_add';

    if (selectedGiftTitle) {
      payload.gift_title = selectedGiftTitle;
    }

    if (giftOfferTitle) {
      payload.gift_offer_title = giftOfferTitle;
    }

    if (giftItemElement) {
      if (giftItemElement.getAttribute('index')) {
        payload.gift_index = giftItemElement.getAttribute('index');
      }

      if (giftItemElement.getAttribute('price-target')) {
        payload.gift_price_target = giftItemElement.getAttribute('price-target');
      }
    }

    if (formElement) {
      if (getGiftVariantId(formElement)) {
        payload.gift_variant_id = getGiftVariantId(formElement);
      }
    }

    return payload;
  }

  /**
   * Desktop only.
   * Hooks into the cart drawer open lifecycle to publish a single event when
   * the drawer is actually opened, regardless of which interaction triggered it.
   */
  function installDesktopCartDrawerOpenTracking() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') {
      return;
    }

    window.customElements.whenDefined('cart-drawer').then(function () {
      var CartDrawerElement = window.customElements.get('cart-drawer');
      var originalOpen;

      if (!CartDrawerElement || CartDrawerElement.__desktopCartDrawerOpenTrackingInstalled) {
        return;
      }

      CartDrawerElement.__desktopCartDrawerOpenTrackingInstalled = true;
      originalOpen = CartDrawerElement.prototype.open;

      CartDrawerElement.prototype.open = function (triggeredBy) {
        var result = originalOpen.apply(this, arguments);

        if (isDesktopTrackingEnabled()) {
          publishCustomEvent(
            DESKTOP_CART_DRAWER_OPEN_EVENT_NAME,
            buildDesktopCartDrawerOpenPayload(this, triggeredBy),
            this
          );
        }

        return result;
      };
    });
  }

  /**
   * Desktop only.
   * Hooks into the facet AJAX lifecycle without changing behavior and publishes
   * a filter apply event only when collection filter parameters actually change.
   */
  function installDesktopCollectionFilterApplyTracking() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') {
      return;
    }

    window.customElements.whenDefined('facet-filters-form').then(function () {
      var FacetFiltersFormElement = window.customElements.get('facet-filters-form');
      var originalRenderPage;
      var originalRenderProductCount;

      if (!FacetFiltersFormElement || FacetFiltersFormElement.__desktopCollectionFilterTrackingInstalled) {
        return;
      }

      FacetFiltersFormElement.__desktopCollectionFilterTrackingInstalled = true;
      FacetFiltersFormElement.__pendingDesktopCollectionFilterApply = null;

      originalRenderPage = FacetFiltersFormElement.renderPage;
      originalRenderProductCount = FacetFiltersFormElement.renderProductCount;

      FacetFiltersFormElement.renderPage = function (searchParams, event, updateURLHash) {
        var previousFilterQuery;
        var nextFilterQuery;
        var nextFilterEntries;

        if (event && isDesktopTrackingEnabled() && isCollectionPage()) {
          previousFilterQuery = serializeFilterParams(
            parseFilterParams(FacetFiltersFormElement.searchParamsPrev || '')
          );

          nextFilterEntries = parseFilterParams(searchParams || '');
          nextFilterQuery = serializeFilterParams(nextFilterEntries);

          if (previousFilterQuery !== nextFilterQuery) {
            FacetFiltersFormElement.__pendingDesktopCollectionFilterApply = {
              triggeredFilterLabel: getTriggeredDesktopFilterLabel(event),
              filterQuery: nextFilterQuery
            };
          } else {
            FacetFiltersFormElement.__pendingDesktopCollectionFilterApply = null;
          }
        } else {
          FacetFiltersFormElement.__pendingDesktopCollectionFilterApply = null;
        }

        return originalRenderPage.apply(this, arguments);
      };

      FacetFiltersFormElement.renderProductCount = function (html) {
        var result = originalRenderProductCount.apply(this, arguments);
        var pendingTracking = FacetFiltersFormElement.__pendingDesktopCollectionFilterApply;
        var activeFilterLabels;
        var payload;

        if (!pendingTracking || !isDesktopTrackingEnabled() || !isCollectionPage()) {
          return result;
        }

        activeFilterLabels = getActiveDesktopFacetLabels();

        payload = buildDesktopCollectionFilterApplyPayload({
          triggeredFilterLabel: pendingTracking.triggeredFilterLabel,
          filterQuery: pendingTracking.filterQuery,
          activeFilterLabels: activeFilterLabels,
          activeFilterCount: activeFilterLabels.length,
          resultCountText: getDesktopProductCountText()
        });

        publishCustomEvent(
          DESKTOP_COLLECTION_FILTER_APPLY_EVENT_NAME,
          payload,
          null
        );

        FacetFiltersFormElement.__pendingDesktopCollectionFilterApply = null;

        return result;
      };
    });
  }

  /**
   * Desktop only.
   * Hooks into the Doofinder layer update event so search result views are
   * counted when results are rendered, not just when the search field is focused.
   */
  function installDesktopDoofinderTracking() {
    document.addEventListener('doofinder.layer.update', function () {
      var payload;
      var query;

      if (!isDesktopTrackingEnabled()) {
        return;
      }

      payload = buildDesktopDoofinderResultsViewPayload();

      if (!payload) {
        lastDoofinderTrackedQuery = '';
        return;
      }

      query = payload.search_term;

      // Doofinder can emit multiple layer updates for one query while results
      // are being refined or extended, so count each search term only once.
      if (!query || query === lastDoofinderTrackedQuery) {
        return;
      }

      lastDoofinderTrackedQuery = query;
      publishCustomEvent(DESKTOP_DOOFINDER_RESULTS_VIEW_EVENT_NAME, payload, null);
    });
  }

  function handleDelegatedClick(event) {
    var index;
    var mapping;
    var matchedElement;
    var payload;
    var detailsElement;
    var isOpening;
    var allowedTabName;

    for (index = 0; index < CLICK_EVENT_MAPPINGS.length; index += 1) {
      mapping = CLICK_EVENT_MAPPINGS[index];
      matchedElement = getClosestMatch(event.target, mapping.selector);

      if (!matchedElement) {
        continue;
      }

      if (
        mapping.eventName === DESKTOP_MEGA_MENU_NAV_EVENT_NAME ||
        mapping.eventName === DESKTOP_MEGA_MENU_PROMO_EVENT_NAME ||
        mapping.eventName === DESKTOP_HEADER_CART_ICON_EVENT_NAME ||
        mapping.eventName === DESKTOP_CART_QUANTITY_BUTTON_EVENT_NAME ||
        mapping.eventName === DESKTOP_DOOFINDER_RESULT_CLICK_EVENT_NAME ||
        mapping.eventName === DESKTOP_PRODUCT_TAB_EVENT_NAME ||
        mapping.eventName === DESKTOP_PDP_VARIANT_EVENT_NAME ||
        mapping.eventName === DESKTOP_PDP_MEDIA_GALLERY_EVENT_NAME ||
        mapping.eventName === DESKTOP_PDP_SUBSCRIPTION_OPTION_EVENT_NAME ||
        mapping.eventName === DESKTOP_COLLECTION_FILTER_OPEN_EVENT_NAME ||
        mapping.eventName === DESKTOP_COLLECTION_QUICK_ADD_EVENT_NAME ||
        mapping.eventName === DESKTOP_PRODUCT_RECOMMENDATION_EVENT_NAME ||
        mapping.eventName === DESKTOP_CART_DRAWER_GIFT_ADD_EVENT_NAME ||
        mapping.eventName === DESKTOP_CART_DRAWER_SAMPLE_SELECT_EVENT_NAME
      ) {
        if (!isDesktopTrackingEnabled()) {
          break;
        }
      }

      if (mapping.eventName === TESTIMONIAL_VIDEO_CLICK_EVENT_NAME) {
        payload = buildTestimonialVideoClickPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === FACE_MAPPING_CTA_EVENT_NAME) {
        payload = buildFaceMappingCtaPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === PROMO_SPOTLIGHT_CLICK_EVENT_NAME) {
        payload = buildPromoSpotlightClickPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_DOOFINDER_RESULT_CLICK_EVENT_NAME) {
        payload = buildDesktopDoofinderResultClickPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === CART_LOYALTY_CLICK_EVENT_NAME) {
        payload = buildCartLoyaltyClickPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_CART_QUANTITY_BUTTON_EVENT_NAME) {
        payload = buildDesktopCartQuantityButtonPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_MEGA_MENU_NAV_EVENT_NAME) {
        payload = buildDesktopMegaMenuNavPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_MEGA_MENU_PROMO_EVENT_NAME) {
        payload = buildDesktopMegaMenuPromoPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_PRODUCT_TAB_EVENT_NAME) {
        detailsElement = matchedElement.closest('details');
        isOpening = detailsElement && !detailsElement.hasAttribute('open');
        allowedTabName = getAllowedProductTabName(matchedElement);

        if (!allowedTabName || !isOpening) {
          break;
        }

        payload = buildDesktopProductTabPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_PDP_VARIANT_EVENT_NAME) {
        matchedElement = getVariantSelectorInput(matchedElement);

        if (!matchedElement || !isProductPage()) {
          break;
        }

        payload = buildDesktopPdpVariantPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_PDP_MEDIA_GALLERY_EVENT_NAME) {
        if (!isProductPage()) {
          break;
        }

        payload = buildDesktopPdpMediaGalleryPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_PDP_SUBSCRIPTION_OPTION_EVENT_NAME) {
        if (!isProductPage()) {
          break;
        }

        payload = buildDesktopPdpSubscriptionOptionPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_COLLECTION_FILTER_OPEN_EVENT_NAME) {
        detailsElement = matchedElement.closest('details');
        isOpening = detailsElement && !detailsElement.hasAttribute('open');

        if (!isCollectionPage() || !isOpening) {
          break;
        }

        payload = buildDesktopCollectionFilterOpenPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_COLLECTION_QUICK_ADD_EVENT_NAME) {
        if (!isCollectionPage()) {
          break;
        }

        payload = buildEventPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_PRODUCT_RECOMMENDATION_EVENT_NAME) {
        payload = buildEventPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_CART_DRAWER_SAMPLE_SELECT_EVENT_NAME) {
        payload = buildDesktopCartDrawerSampleSelectPayload(matchedElement, mapping.selector);
      } else if (mapping.eventName === DESKTOP_CART_DRAWER_GIFT_ADD_EVENT_NAME) {
        payload = buildDesktopCartDrawerGiftAddPayload(matchedElement, mapping.selector);
      } else {
        payload = buildEventPayload(matchedElement, mapping.selector);
      }

      publishCustomEvent(mapping.eventName, payload, matchedElement);
      break;
    }
  }

  /**
   * Tracks the first Gorgias widget open per page view.
   * This event is intentionally limited to one publish to avoid repeated chat-open noise.
   */
  function initGorgiasTracking() {
    var initGorgiasChatPromise;

    if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
      initGorgiasChatPromise = Promise.resolve(window.GorgiasChat.init());
    } else {
      initGorgiasChatPromise = new Promise(function (resolve) {
        window.addEventListener(
          'gorgias-widget-loaded',
          function () {
            resolve();
          },
          { once: true }
        );
      });
    }

    initGorgiasChatPromise
      .then(function () {
        if (!window.GorgiasChat || typeof window.GorgiasChat.on !== 'function') {
          return;
        }

        window.GorgiasChat.on('widget:opened', function () {
          if (hasTrackedChatOpen) {
            return;
          }

          hasTrackedChatOpen = true;

          publishCustomEvent(CHAT_OPEN_EVENT_NAME, {
            url: window.location.href,
            pathname: window.location.pathname,
            timestamp: new Date().toISOString()
          });
        });
      })
      .catch(function (error) {
        console.error('Gorgias tracking init failed:', error);
      });
  }

  // Use capture so click events are observed before navigation changes the page.
  document.addEventListener('click', handleDelegatedClick, true);

  installDesktopCartDrawerOpenTracking();
  installDesktopCollectionFilterApplyTracking();
  installDesktopDoofinderTracking();
  initGorgiasTracking();
})();
